import type { SVGProps } from "react";

const SvgRevolutSmallLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0.0 0.0 800.0 800.0"
    xmlSpace="preserve"
    width="1em"
    height="1em"
    {...props}
  >
    <path
      d="M0 0h800v800H0z"
      style={{
        fill: "#fff",
      }}
    />
    <path d="M209.051 262.097h101.445v410.21H209.051z" />
    <path d="M628.623 285.554c0-87.043-70.882-157.86-158.011-157.86H209.051v87.603h249.125c39.43 0 72.093 30.978 72.814 69.051.361 19.064-6.794 37.056-20.146 50.66-13.357 13.61-31.204 21.109-50.251 21.109h-97.046c-3.446 0-6.25 2.8-6.25 6.245v77.859a6.2 6.2 0 0 0 1.179 3.656l164.655 228.43h120.53L478.623 443.253c83.113-4.173 150-74.005 150-157.699" />
  </svg>
);
export default SvgRevolutSmallLogo;
